import { createContext, useContext } from 'react'

import { AuthStore } from './Auth'

export const AuthContext = createContext<AuthStore | undefined>(undefined)

export function useAuth() {
  const auth = useContext(AuthContext)
  if (!auth) {
    throw new Error('Must use useAuth within an AuthContext')
  }
  return auth
}
